import { render, staticRenderFns } from "./setnewpassword.vue?vue&type=template&id=40b3f6ba&scoped=true"
import script from "./setnewpassword.vue?vue&type=script&lang=js"
export * from "./setnewpassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b3f6ba",
  null
  
)

export default component.exports